<h1 mat-dialog-title class="mat-headline">Sind Sie sich Sicher?</h1>
<div mat-dialog-content class="content">
    <p>{{data.name}}</p>
    <p *ngIf="data.warn" class="warn-color">{{data.warn}}</p>
</div>
<div mat-dialog-actions class="buttons">
    <button app-button class="button" (click)="onNoClick()">Nein</button>
    <button app-button class="button" (click)="onYesClick()">Ja</button>
</div>
